import React from 'react';
import cn from 'classnames';
import { selectCurrentUser } from "../../store/userSlice/userSelectors";
import { useDispatch, useSelector } from "react-redux";
import { palette } from "../../theme";
import { Avatar, Card, Divider, Grid2, Link, Popover, Typography } from "@mui/material";
import { logout } from "../../store/userSlice/userSlice";
import InnerLink from "../../components/InnerLink";
import { PAGE_LIST } from "../../pages";

import classes from "./index.module.scss";

const ProfileAvatar = () => {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const avatarName = (user.firstName || '').slice(0, 1) + (user.lastName || '').slice(0, 1) || user.email.slice(0, 1);
  const name = user.firstName;
  const fullName = (user.firstName || '') + ' ' + (user.lastName || '');
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onLogout = () => {
    dispatch(logout());
    window.location.reload();
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <>
      <Grid2 container direction='row' className={cn(classes.center, classes.clickable)} onClick={handleClick}>
        <Grid2 className={classes.avatar}>
          <Avatar sx={{ bgcolor: palette.primary.main }}>{avatarName}</Avatar>
        </Grid2>
        <Grid2>
          <Typography variant='body2' className={classes.userName}>{name}</Typography>
        </Grid2>
      </Grid2>
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Card
          className={classes.paper}
        >
          <Grid2 container size={12}>
            <Grid2 size={12} className={classes.paperCell}><Typography variant='body1' className={classes.bold}>{fullName}</Typography></Grid2>
            <Grid2 size={12} className={classes.paperCell}><Typography variant='body1' className={classes.email}>{user?.email}</Typography></Grid2>
            <Divider className={classes.divider} />
            <Grid2 size={12} className={classes.paperCell}>
              <InnerLink href={PAGE_LIST.PROFILE} className={classes.link}><Typography variant='body1'>Profile</Typography></InnerLink>
            </Grid2>
            <Divider className={classes.divider} />
            <Grid2 size={12} className={classes.paperCell}>
              <Link onClick={onLogout} className={classes.link}><Typography variant='body1'>Log out</Typography></Link>
            </Grid2>
          </Grid2>
        </Card>
      </Popover>
    </>
  );
}

export default ProfileAvatar;